import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'UploadIcon',
  viewBox: '0 0 20 20',
  defaultProps: {
    boxSize: 4,
  },
  path: (
    <>
      <path
        d="M10.75 13.25C10.75 13.6642 10.4142 14 10 14C9.58579 14 9.25 13.6642 9.25 13.25V4.63642L6.29526 7.76497C6.01085 8.06611 5.53617 8.07967 5.23503 7.79526C4.9339 7.51085 4.92033 7.03617 5.20474 6.73503L9.45474 2.23503C9.59642 2.08502 9.79366 2 10 2C10.2063 2 10.4036 2.08502 10.5453 2.23503L14.7953 6.73503C15.0797 7.03617 15.0661 7.51085 14.765 7.79526C14.4638 8.07967 13.9892 8.06611 13.7047 7.76497L10.75 4.63642V13.25Z"
        fill="currentColor"
      />
      <path
        d="M3.5 12.75C3.5 12.3358 3.16421 12 2.75 12C2.33579 12 2 12.3358 2 12.75V15.25C2 16.7688 3.23122 18 4.75 18H15.25C16.7688 18 18 16.7688 18 15.25V12.75C18 12.3358 17.6642 12 17.25 12C16.8358 12 16.5 12.3358 16.5 12.75V15.25C16.5 15.9404 15.9404 16.5 15.25 16.5H4.75C4.05964 16.5 3.5 15.9404 3.5 15.25V12.75Z"
        fill="currentColor"
      />
    </>
  ),
});
